import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Typography,
  Box,
  IconButton,
  Radio,
  RadioGroup,
  FormControlLabel,
  ListSubheader,
} from "@material-ui/core";
import { Delete, Add } from "@material-ui/icons";
import { toast } from "react-toastify";

const REGRAS = [
  { v: 1, t: "é igual a" },
  { v: 6, t: "contém" },
  { v: 2, t: "maior ou igual a" },
  { v: 3, t: "menor ou igual a" },
  { v: 4, t: "menor que" },
  { v: 5, t: "maior que" },
];

const CAMPOS = [
  {
    grupo: "Sistema",
    itens: [
      { k: "sys.etiqueta", t: "Etiqueta do contato", ex: "Ex: Cliente VIP" },
      { k: "sys.diaSemana", t: "Dia da semana", ex: "domingo, segunda, terca, quarta, quinta, sexta, sabado" },
      { k: "sys.hora", t: "Hora agora", ex: "Ex: 18:00" },
      { k: "sys.data", t: "Data de hoje", ex: "Ex: 2026-12-25" },
    ],
  },
  {
    grupo: "Atendimento",
    itens: [
      { k: "sys.status", t: "Status do atendimento", ex: "aguardando, atendendo ou resolvido" },
      { k: "sys.atendente", t: "Atendente do chat", ex: "Ex: Maria" },
    ],
  },
  {
    grupo: "Contato",
    itens: [
      { k: "contato.nome", t: "Nome", ex: "Ex: João" },
      { k: "contato.numero", t: "Número", ex: "Ex: 5511999999999" },
      { k: "contato.email", t: "Email", ex: "Ex: joao@email.com" },
    ],
  },
  {
    grupo: "Anúncio (Click-to-WhatsApp)",
    itens: [
      { k: "anuncio_id", t: "ID do anúncio", ex: "Ex: 120210000111222" },
      { k: "anuncio_titulo", t: "Título do anúncio", ex: "Ex: Promo de Julho" },
      { k: "__ctwaClid", t: "Código de rastreio", ex: "" },
    ],
  },
];

const novaCondicao = () => ({ key: "", condition: 1, value: "" });

const FlowBuilderConditionModal = ({ open, onSave, onUpdate, data, close, flowNodes }) => {
  const [activeModal, setActiveModal] = useState(false);
  const [logic, setLogic] = useState("and");
  const [conditions, setConditions] = useState([novaCondicao()]);

  const varsDoFluxo = (Array.isArray(flowNodes) ? flowNodes : [])
    .map((n) => {
      const d = n?.data || {};
      return (
        d?.variableConfig?.variableName ||
        d?.answerKey ||
        d?.data?.answerKey ||
        d?.typebotIntegration?.answerKey
      );
    })
    .filter((v, i, arr) => v && arr.indexOf(v) === i);

  useEffect(() => {
    if (open === "edit") {
      const d = data?.data || data || {};
      setLogic(d.logic || "and");
      if (Array.isArray(d.conditions) && d.conditions.length) {
        setConditions(d.conditions);
      } else if (d.key) {
        setConditions([{ key: d.key, condition: d.condition || 1, value: d.value || "" }]);
      } else {
        setConditions([novaCondicao()]);
      }
      setActiveModal(true);
    } else if (open === "create") {
      setLogic("and");
      setConditions([novaCondicao()]);
      setActiveModal(true);
    }
  }, [open, data]);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const alterar = (i, patch) =>
    setConditions((old) => old.map((c, idx) => (idx === i ? { ...c, ...patch } : c)));

  const remover = (i) =>
    setConditions((old) => (old.length === 1 ? old : old.filter((_, idx) => idx !== i)));

  const dicaDoCampo = (k) => {
    for (const g of CAMPOS) {
      const achou = g.itens.find((it) => it.k === k);
      if (achou) return achou.ex;
    }
    return "Valor a comparar";
  };

  const handleSave = () => {
    const validas = conditions.filter((c) => c.key && String(c.key).trim());
    if (!validas.length) {
      toast.error("Adicione ao menos uma condição com um campo escolhido.");
      return;
    }
    const payload = {
      logic,
      conditions: validas,
      // compatibilidade com o formato antigo
      key: validas[0].key,
      condition: validas[0].condition,
      value: validas[0].value,
    };
    if (open === "edit") {
      onUpdate({ ...data, data: { ...(data?.data || {}), ...payload } });
    } else {
      onSave(payload);
    }
    handleClose();
  };

  return (
    <Dialog open={activeModal} onClose={handleClose} maxWidth="sm" fullWidth scroll="paper">
      <DialogTitle>{open === "create" ? "Adicionar condição" : "Editar condição"}</DialogTitle>
      <DialogContent dividers>
        <Typography style={{ fontSize: 13, fontWeight: 600, marginBottom: 4 }}>
          Regra lógica
        </Typography>
        <RadioGroup value={logic} onChange={(e) => setLogic(e.target.value)}>
          <FormControlLabel
            value="and"
            control={<Radio size="small" color="primary" />}
            label={<span style={{ fontSize: 13 }}>Precisa cumprir <b>todas</b> as condições (e)</span>}
          />
          <FormControlLabel
            value="or"
            control={<Radio size="small" color="primary" />}
            label={<span style={{ fontSize: 13 }}>Basta cumprir <b>qualquer</b> condição (ou)</span>}
          />
        </RadioGroup>

        <Box style={{ display: "flex", alignItems: "center", marginTop: 12, marginBottom: 8 }}>
          <Typography style={{ fontSize: 13, fontWeight: 600, flex: 1 }}>Condições</Typography>
          <Button
            size="small"
            startIcon={<Add />}
            onClick={() => setConditions((old) => [...old, novaCondicao()])}
            style={{ textTransform: "none" }}
          >
            Adicionar condição
          </Button>
        </Box>

        {conditions.map((c, i) => (
          <Box
            key={i}
            style={{
              border: "1px solid #e5e7eb",
              borderRadius: 10,
              padding: 12,
              marginBottom: 10,
            }}
          >
            <Box style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
              <Typography style={{ fontSize: 12, color: "#6b7280", flex: 1 }}>
                Condição {i + 1}
              </Typography>
              {conditions.length > 1 && (
                <IconButton size="small" onClick={() => remover(i)}>
                  <Delete fontSize="small" style={{ color: "#dc2626" }} />
                </IconButton>
              )}
            </Box>

            <TextField
              select
              label="Campo"
              value={c.key || ""}
              onChange={(e) => alterar(i, { key: e.target.value })}
              fullWidth
              size="small"
              variant="outlined"
              style={{ marginBottom: 8 }}
            >
              {CAMPOS.map((g) => [
                <ListSubheader key={g.grupo}>{g.grupo}</ListSubheader>,
                ...g.itens.map((it) => (
                  <MenuItem key={it.k} value={it.k}>
                    {it.t}
                  </MenuItem>
                )),
              ])}
              {varsDoFluxo.length > 0 && (
                <ListSubheader key="fluxo">Variáveis do seu fluxo</ListSubheader>
              )}
              {varsDoFluxo.map((v) => (
                <MenuItem key={`v-${v}`} value={v}>
                  {v}
                </MenuItem>
              ))}
            </TextField>

            <Box style={{ display: "flex", gap: 8 }}>
              <TextField
                select
                label="Regra"
                value={c.condition || 1}
                onChange={(e) => alterar(i, { condition: e.target.value })}
                size="small"
                variant="outlined"
                style={{ width: 190 }}
              >
                {REGRAS.map((r) => (
                  <MenuItem key={r.v} value={r.v}>
                    {r.t}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                label="Valor"
                value={c.value || ""}
                onChange={(e) => alterar(i, { value: e.target.value })}
                size="small"
                variant="outlined"
                style={{ flex: 1 }}
                helperText={dicaDoCampo(c.key)}
              />
            </Box>
          </Box>
        ))}

        <Box style={{ background: "#f8fafc", borderRadius: 10, padding: 12 }}>
          <Typography style={{ fontSize: 13, fontWeight: 600, marginBottom: 4 }}>
            Como funciona
          </Typography>
          <Typography style={{ fontSize: 12, color: "#6b7280", lineHeight: 1.6 }}>
            Se as condições forem atendidas, o fluxo segue pela saída <b>verdadeiro</b>.
            Senão, vai pela saída <b>falso</b>. Comparações de texto ignoram maiúsculas
            e minúsculas, e horários no formato 09:30 são comparados corretamente.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button onClick={handleSave} color="primary" variant="contained">
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderConditionModal;
